import React, { useState } from "react";
import { Tooltip } from "./Tooltip";
import { Button, ButtonProps } from "./Button";

interface TooltipButtonProps extends ButtonProps {
  title: string;
  disableTooltip?: boolean;
}

export const TooltipButton = ({
  title,
  disableTooltip = false,
  onClick,
  ...buttonProps
}: TooltipButtonProps) => {
  const [hovered, setHovered] = useState(false);
  const [blocked, setBlocked] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setBlocked(true);
    onClick?.(e);
  };

  const open = !disableTooltip && !blocked && hovered;

  // Wrapper span stays mounted across click/hover state changes so the
  // underlying <button> DOM node is stable — Popover consumers that capture
  // anchorEl from event.currentTarget can rely on it not being detached.
  return (
    <Tooltip title={title} instant open={open}>
      <span
        className="inline-flex items-center justify-center"
        onPointerEnter={() => setHovered(true)}
        onPointerLeave={() => {
          setHovered(false);
          setBlocked(false);
        }}
      >
        <Button {...buttonProps} onClick={handleClick} />
      </span>
    </Tooltip>
  );
};
